import { render, staticRenderFns } from "./payslipitems.vue?vue&type=template&id=52b4adb1&scoped=true"
import script from "./payslipitems.vue?vue&type=script&lang=js"
export * from "./payslipitems.vue?vue&type=script&lang=js"
import style0 from "./payslipitems.vue?vue&type=style&index=0&id=52b4adb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b4adb1",
  null
  
)

export default component.exports